module.exports = {
	"_args": [
		[
			"elliptic@^6.0.0",
			"/home/louisedm/gowork/src/github.com/mattermost/platform/webapp/node_modules/browserify-sign"
		]
	],
	"_from": "elliptic@>=6.0.0 <7.0.0",
	"_id": "elliptic@6.2.8",
	"_inCache": true,
	"_installable": true,
	"_location": "/elliptic",
	"_nodeVersion": "6.0.0",
	"_npmOperationalInternal": {
		"host": "packages-12-west.internal.npmjs.com",
		"tmp": "tmp/elliptic-6.2.8.tgz_1464746004719_0.6379144776146859"
	},
	"_npmUser": {
		"email": "fedor@indutny.com",
		"name": "indutny"
	},
	"_npmVersion": "3.8.6",
	"_phantomChildren": {},
	"_requested": {
		"name": "elliptic",
		"raw": "elliptic@^6.0.0",
		"rawSpec": "^6.0.0",
		"scope": null,
		"spec": ">=6.0.0 <7.0.0",
		"type": "range"
	},
	"_requiredBy": [
		"/browserify-sign",
		"/create-ecdh"
	],
	"_resolved": "https://registry.npmjs.org/elliptic/-/elliptic-6.2.8.tgz",
	"_shasum": "44a25b3d1550bebb74d0b6d22d89940206b51739",
	"_shrinkwrap": null,
	"_spec": "elliptic@^6.0.0",
	"_where": "/home/louisedm/gowork/src/github.com/mattermost/platform/webapp/node_modules/browserify-sign",
	"author": {
		"email": "fedor@indutny.com",
		"name": "Fedor Indutny"
	},
	"bugs": {
		"url": "https://github.com/indutny/elliptic/issues"
	},
	"dependencies": {
		"bn.js": "^4.0.0",
		"brorand": "^1.0.1",
		"hash.js": "^1.0.0",
		"inherits": "^2.0.1"
	},
	"description": "EC cryptography",
	"devDependencies": {
		"brfs": "^1.4.3",
		"coveralls": "^2.11.3",
		"grunt": "^0.4.5",
		"grunt-browserify": "^5.0.0",
		"grunt-contrib-connect": "^1.0.0",
		"grunt-contrib-copy": "^1.0.0",
		"grunt-contrib-uglify": "^1.0.1",
		"grunt-mocha-istanbul": "^3.0.1",
		"grunt-saucelabs": "^8.6.2",
		"istanbul": "^0.4.2",
		"jscs": "^2.9.0",
		"jshint": "^2.6.0",
		"mocha": "^2.1.0"
	},
	"directories": {},
	"dist": {
		"shasum": "44a25b3d1550bebb74d0b6d22d89940206b51739",
		"tarball": "https://registry.npmjs.org/elliptic/-/elliptic-6.2.8.tgz"
	},
	"files": [
		"lib"
	],
	"gitHead": "236f37395bdf9e4af1dfc8e84f6353bce540b93e",
	"homepage": "https://github.com/indutny/elliptic",
	"keywords": [
		"EC",
		"Elliptic",
		"curve",
		"Cryptography"
	],
	"license": "MIT",
	"main": "lib/elliptic.js",
	"maintainers": [
		{
			"email": "fedor@indutny.com",
			"name": "indutny"
		}
	],
	"name": "elliptic",
	"optionalDependencies": {},
	"readme": "ERROR: No README data found!",
	"repository": {
		"type": "git",
		"url": "git+ssh://git@github.com/indutny/elliptic.git"
	},
	"scripts": {
		"jscs": "jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js",
		"jshint": "jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js",
		"lint": "npm run jscs && npm run jshint",
		"test": "npm run lint && npm run unit",
		"unit": "istanbul test _mocha --reporter=spec test/index.js",
		"version": "grunt dist && git add dist/"
	},
	"version": "6.2.8"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/elliptic/package.json
 ** module id = 1755
 ** module chunks = 0
 **/